module.exports = __webpack_public_path__ + "static/media/terraNord.27cdea04.jpg";